import React from 'react'

interface CanvasWindowMaximizeIconProps {
  size?: number
  className?: string
}

/**
 * „Canvas maximieren" — linkes Segment der Fenster-Umschaltgruppe im
 * geteilten Zustand (Figma `btn Maximize` 4872:100260).
 *
 * Derselbe Rahmen wie {@link CanvasWindowCloseIcon}, darin das 12×12-Pfeilkreuz
 * aus Figmas `Frame` (4874:110710), um 4px eingerückt. Dessen Striche stehen
 * im Figma bewusst dünner (1) als der Rahmen (1.33) — das ist keine
 * Ungenauigkeit, sondern lässt das Kreuz im kleinen Feld ruhiger wirken.
 */
export const CanvasWindowMaximizeIcon: React.FC<CanvasWindowMaximizeIconProps> = ({ size = 20, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="1.335"
      y="2.335"
      width="17.33"
      height="15.33"
      rx="4.665"
      stroke="currentColor"
      strokeWidth="1.33"
    />
    <g stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11.5 5.5H14.5V8.5" />
      <path d="M14.5 5.5L11 9" />
      <path d="M5.5 14.5L9 11" />
      <path d="M8.5 14.5H5.5V11.5" />
    </g>
  </svg>
)
